// action dispatchers
export const setUserApplicationsPermissions = userApplications => ({
  type: 'SET_USER_APPLICATIONS_PERMISSIONS',
  userApplications
});

export const updateUserApplicationsPermissions = (appId, permissionIds) => ({
  type: 'UPDATE_USER_APPLICATIONS_PERMISSIONS',
  appId,
  permissionIds
});

export const unSetUserApplicationsPermissions = () => ({
  type: 'UNSET_USER_APPLICATIONS_PERMISSIONS'
});